import React from 'react'

import {
  AgeGateCard,
  BannerAppearanceCard,
  BannerCompilationCard,
  BannerConfigurationCard,
  BannerLayoutCard,
  CookieClassificationCard,
  CookiePolicyCard,
  CookieScannerCard,
} from '../index'

import useCookieBanner from 'hooks/useCookieBanner'

import constants from 'constants/index'

const { STEPS } = constants.cookies.banner

const StepContent = () => {
  const { activeStep } = useCookieBanner()

  const stepComponents = {
    [STEPS.CONFIGURATION]: <BannerConfigurationCard />,
    [STEPS.APPEARANCE]: <BannerAppearanceCard />,
    [STEPS.BANNER_LAYOUT]: <BannerLayoutCard />,
    [STEPS.AGE_GATE]: <AgeGateCard />,
    [STEPS.SCANNER]: <CookieScannerCard />,
    [STEPS.CLASSIFICATION]: <CookieClassificationCard />,
    [STEPS.INSTALLATION]: <BannerCompilationCard />,
    [STEPS.COOKIE_POLICY]: <CookiePolicyCard />,
  }

  return stepComponents[activeStep] || null
}

export default StepContent
